(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-flexible-jv"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.jvInitialized) return;
    root.dataset.jvInitialized = 'true';
    root.querySelectorAll('[data-jv-promo-timer]').forEach((element) => {
      const endTime = Date.now() + 1800000;
      let interval;
      const update = () => {
        if (!element.isConnected) { clearInterval(interval); return; }
        const remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
        element.textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
        if (!remaining) clearInterval(interval);
      };
      interval = setInterval(update, 1000);
      update();
    });
    const main = root.querySelector('.jv-featured-image');
    const thumbs = [...root.querySelectorAll('.jv-thumbnail')];
    const showImage = (url, alt) => {
      if (!main || !url) return;
      main.removeAttribute('srcset');
      main.src = url;
      main.alt = alt || '';
      thumbs.forEach((thumb) => {
        const active = thumb.dataset.image === url;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(thumb.dataset.image, thumb.dataset.alt)));
    const quantity = root.querySelector('[data-jv-quantity]');
    const checkoutQuantity = root.querySelector('[data-jv-checkout-quantity]');
    const syncCheckoutQuantity = () => {
      if (!checkoutQuantity) return;
      const value = quantity ? Number(quantity.value) : 1;
      checkoutQuantity.value = String(Number.isFinite(value) ? Math.max(1, Math.floor(value)) : 1);
    };
    quantity?.addEventListener('input', syncCheckoutQuantity);
    quantity?.addEventListener('change', syncCheckoutQuantity);
    root.addEventListener('click', syncCheckoutQuantity, true);
    root.addEventListener('submit', syncCheckoutQuantity, true);
    syncCheckoutQuantity();
    const minus = root.querySelector('[data-jv-quantity-minus]');
    const plus = root.querySelector('[data-jv-quantity-plus]');
    if (quantity && minus && plus) {
      const normalize = () => {
        const minimum = Number(quantity.min) || 1;
        const maximum = quantity.max ? Number(quantity.max) : Infinity;
        const number = Number(quantity.value);
        const value = Number.isFinite(number) ? Math.floor(number) : minimum;
        quantity.value = Math.min(maximum, Math.max(minimum, value));
        minus.disabled = Number(quantity.value) <= minimum;
        plus.disabled = Number(quantity.value) >= maximum;
      };
      const changeQuantity = (delta) => {
        normalize();
        quantity.value = Number(quantity.value) + delta;
        normalize();
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      };
      minus.addEventListener('click', () => changeQuantity(-1));
      plus.addEventListener('click', () => changeQuantity(1));
      quantity.addEventListener('change', normalize);
      quantity.addEventListener('input', () => {
        minus.disabled = !Number.isFinite(quantity.valueAsNumber) || quantity.valueAsNumber <= 1;
      });
      normalize();
    }
    const picker = root.querySelector('[data-jv-variant-picker]');
    const form = root.querySelector('.jv-product-form');
    if (form && quantity) quantity.addEventListener('change', () => form.dispatchEvent(new Event('change', { bubbles: true })));
    if (form) form.addEventListener('submit', () => {
      if (quantity) quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
    const updateVariant = () => {
      const selected = picker && picker.selectedOptions[0];
      if (!selected) return;
      const available = selected.dataset.available === 'true';
      root.querySelectorAll('[data-jv-plan]').forEach((radio) => {
        radio.checked = radio.value === selected.value;
        radio.closest('.jv-plan').classList.toggle('is-selected', radio.checked);
      });
      root.querySelectorAll('[data-jv-promo-discount]').forEach((el) => {
        const saving = Number(selected.dataset.saving || 0);
        el.textContent = saving > 0 ? saving + '% OFF' : el.dataset.fallback;
      });
      root.querySelectorAll('[data-jv-price]').forEach((el) => { el.innerHTML = selected.dataset.price; });
      root.querySelectorAll('[data-jv-compare]').forEach((el) => {
        el.innerHTML = selected.dataset.compare || '';
        el.hidden = !selected.dataset.compare || el.closest('.jv-product-price').dataset.jvShowCompare === 'false';
      });
      root.querySelectorAll('[data-jv-saving]').forEach((el) => {
        const saving = Number(selected.dataset.saving || 0);
        el.querySelector('[data-jv-saving-value]').textContent = saving;
        el.hidden = saving < 1 || el.closest('.jv-product-price').dataset.jvShowSaving === 'false';
      });
      root.querySelectorAll('[data-jv-variant-id]').forEach((el) => {
        el.value = selected.value;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
      const button = root.querySelector('[data-jv-add]');
      if (button) {
        button.disabled = !available;
        button.querySelector('.jv-cart-label').textContent = available ? button.dataset.label : button.dataset.soldLabel;
      }
      const card = root.querySelector('[data-jv-card-checkout]');
      if (card) card.disabled = !available;
      const express = root.querySelector('[data-jv-dynamic-checkout]');
      if (express) {
        express.hidden = !available;
        express.querySelectorAll('.jv-stripe-wallet-button').forEach((walletButton) => { walletButton.disabled = !available; });
      }
      if (selected.dataset.image) showImage(selected.dataset.image, selected.dataset.imageAlt);
    };
    root.querySelectorAll('[data-jv-plan]').forEach((radio) => radio.addEventListener('change', () => {
      if (!picker || !radio.checked) return;
      picker.value = radio.value;
      picker.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    if (picker) {
      picker.addEventListener('change', () => {
        updateVariant();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', picker.value);
        try { window.history.replaceState({}, '', url); } catch (_) {}
      });
      updateVariant();
    }
  };
  const scan = () => document.querySelectorAll('[data-jv-flexible-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();
})();
